var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('datepicker',{attrs:{"format":_vm.dateFormat,"language":"sv","input-class":"form-control","monday-first":true,"clear-button":true},on:{"selected":_vm.updateDate},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }